import Vue from 'vue'
import App from './App.vue'

// Polyfills
import smoothscroll from 'smoothscroll-polyfill'
import cssVars from 'css-vars-ponyfill'

import router from '@/router'
import VueCookies from 'vue-cookies'
import MyMixin from '@/misc/constant'
import VModal from 'vue-js-modal'
import VueLazyload from 'vue-lazyload'
import InlineSvg from 'vue-inline-svg'
import observer from 'vue-mutation-observer'
import vuePositionSticky from 'vue-position-sticky'
import { pSBC } from '@/misc/misc-function'

smoothscroll.polyfill()
cssVars({
  onlyLegacy: true
})

Vue.component('inline-svg', InlineSvg)
Vue.use(observer)
Vue.use(VueCookies)
Vue.mixin(MyMixin, pSBC)
Vue.use(VModal)
Vue.use(vuePositionSticky)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: wpvue_script_data_params.data.site_data.image_loader ? wpvue_script_data_params.data.site_data.image_loader : `${wpvue_script_data_params.site_url}/wp-content/themes/wpvue/src/assets/img-loader/loader.gif`,
  error: `${wpvue_script_data_params.site_url}/wp-content/themes/wpvue/src/assets/img-loader/error.png`,
  attempt: 2
})

Vue.config.errorHandler = function (err, com, info) {
  console.log(`Error: ${err.message}\nBlock Name: ${com.$options._componentTag}`)
}

Vue.config.ignoredElements = [
  'home-banner',
  'casino-toplist',
  'main-casino-toplist',
  'blue-progressive-block',
  'content-icon-block',
  'game-guide-categories',
  'best-payment-methods',
  'home-card-testimonials',
  'whitebg-content',
  'faq-block',
  'top-games',
  'tab-switcher',
  'latest-casino',
  'user-testimonials',
  'comparison-list',
  'published-date',
  'geo-text',
  'geo-image',
  'yoast-faq',
  'author-block',
  'team-block',
  'poker-hands',
  'youtube-film-strip',
  'home-promote-banner',
  'exclusive-casino',
  'article-banner',
  'howto-block',
  'article-helpful-vote',
  'related-articles',
  'other-software-provider',
  'intro-block',
  'bonus-cards',
  'bullet-block',
  'top-games-articles',
  'alternative-software-provider',
  'alternative-payment-options',
  'similar-casinos',
  'newsletter-block',
  'core-shortcode',
  "stream-block",
  'news-block',
  'top-promotions',
  'feature-promotion',
  'software-provider-block',
  'payment-option-block',
  'languages-supports-block',
  'bonus-information-block',
  'core-content',
  'link-block',
  'pu-reference'
]

new Vue({
  data: {
    loading: false,
    casloading: false,
    maincasloading: false,
    disable: false,
    hasPlay: false,
    adminBarData: {},
    disableNotSupportBanner: false,
    notsupportbannerData: {},
    notsupportassetSizes: {},
    noScroll: false,
    notSupportPageType: "",
    notSupportType: "",
    pathValue: 0,
    selectedState: {},
    show_footer: !wpvue_script_data_params.data.site_data.enable_lazyload,
    show_stickymenu: wpvue_script_data_params.data.site_data.enable_stickymenu,
    show_stickymenu_desktop: wpvue_script_data_params.data.site_data.stickymenu_desktop,
    show_stickymenu_mobile: wpvue_script_data_params.data.site_data.stickymenu_mobile,
    game_overlay_screen_time: wpvue_script_data_params.data.site_data.game_overlay_screen_time,
    enable_api_auth_secret: wpvue_script_data_params.data.site_data.enable_api_auth_secret,
    api_auth_secret: wpvue_script_data_params.data.site_data.api_auth_secret,
    routes_meta: wpvue_script_data_params.data.routes_meta,
    site_url: wpvue_script_data_params.site_url,
    user_id: wpvue_script_data_params.user_id,
    page404_id: wpvue_script_data_params.page404_id,
    page404_slug: wpvue_script_data_params.page404_slug,
    asset_path: '/wp-content/themes/wpvue/src/assets/images',
    color_schema: wpvue_script_data_params.data.site_data.color_schema,
    font_family: wpvue_script_data_params.data.site_data.font_family,
    default_display: wpvue_script_data_params.data.site_data.cas_data.default_display,
    display_offset: wpvue_script_data_params.data.site_data.cas_data.display_offset,
    enable_partner_name_review_link: wpvue_script_data_params.data.site_data.cas_data.enable_partner_name_review_link,
    enable_lazyload: wpvue_script_data_params.data.site_data.enable_lazyload,
    i18n: wpvue_script_data_params.i18n,
    goto_link: wpvue_script_data_params.data.site_data.color_schema.promote_partner ? wpvue_script_data_params.data.site_data.color_schema.promote_partner.go_link : '',
    slug: wpvue_script_data_params.data.site_data.color_schema.promote_partner ? wpvue_script_data_params.data.site_data.color_schema.promote_partner.slug : '',
    listname: wpvue_script_data_params.data.site_data.aweber_listname,
    homepageId: wpvue_script_data_params.frontpage_id,
    //aweber: wpvue_script_data_params.data.site_data.aweber,
    campaignmonitor: wpvue_script_data_params.data.site_data.campaignmonitor,
    wp_country: wpvue_script_data_params.data.site_data.country,
    wp_state: wpvue_script_data_params.data.site_data.state,
    po_qty: wpvue_script_data_params.data.site_data.cas_data.po_qty,
    sp_qty: wpvue_script_data_params.data.site_data.cas_data.sp_qty,
    free_games_global_countries: wpvue_script_data_params.data.site_data.cas_data.free_games_global_countries,
    youtube_script_path: wpvue_script_data_params.data.site_data.youtube_script_path,
    custom_loader: wpvue_script_data_params.data.site_data.loader,
    user_agents: wpvue_script_data_params.data.site_data.user_agents,
    asset_sizes: wpvue_script_data_params.data.site_data.asset_sizes,
    disable_freegame_banner_outlink: wpvue_script_data_params.data.site_data.disable_freegame_banner_outlink,
    image_loader: wpvue_script_data_params.data.site_data.image_loader,
    enable_cta_partner_bonus: wpvue_script_data_params.data.site_data.cas_data.enable_cta_partner_bonus,
    enable_cta_partner_logo: wpvue_script_data_params.data.site_data.cas_data.enable_cta_partner_logo,
    hide_game_playnow_btn: wpvue_script_data_params.data.site_data.hide_game_playnow_btn,
    change_cta_to_sponsored: wpvue_script_data_params.data.site_data.cas_data.change_cta_to_sponsored,
    disable_bonus_cta_on_review: wpvue_script_data_params.data.site_data.cas_data.disable_bonus_cta_on_review,
    enable_piwik_reload: wpvue_script_data_params.data.site_data.enable_piwik_reload,
    disable_not_supported_banner: wpvue_script_data_params.data.site_data.cas_data.disable_not_supported_banner,
    enable_loader: wpvue_script_data_params.data.site_data.enable_loader,
    override_ctabtntxt_color: wpvue_script_data_params.data.site_data.color_schema.override_ctabtntxt_color,
    ctabtn_txt_color: wpvue_script_data_params.data.site_data.color_schema.ctabtn_txt_color,
    body_loading_status: false,
    page_side_images: wpvue_script_data_params.data.site_data.page_side_images,
  },
  router,
  render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js